<template>
  <div class="mainMap">
    <div id="bMain"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-extension-amap";
import mapJson from "@/assets/map.json";
import companyData from "@/assets/companyData.json";
import InfoWindow from "./InfoWindow.vue";
import Vue from "vue";
var myChart;
export default {
  name: "Map",
  props: {
    zoom: {
      type: Number,
      default: 9,
    },
    activeCom: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      points: companyData,
      center: [120.739743, 31.344089], //苏州总部为中心点
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.Binit();
    });
  },
  watch: {
    activeCom(val) {
      this.popWindow(this.activeCom, false);
    },
  },
  methods: {
    Binit() {
      var pointsLines = [];
      var xData = [];
      myChart = echarts.init(document.getElementById("bMain"));
      myChart.setOption({
        backgroundColor: "transparent",
        amap: {
          center: this.center,
          zoom: this.zoom,
          viewMode: "3D",
          resizeEnable: true,
          mapStyle: "amap://styles/normal",
        },
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "amap",
            showEffectOn: "render",
            zlevel: 1,
            rippleEffect: {
              period: 5,
              scale: 5,
              brushType: "fill",
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: (params) => {
                  var str = "";
                  str = "            " + params.data.name;
                  return str;
                },
                position: "right",
                offset: [40, 5],
                color: "#F69638",
                show: true,
              },
            },
            itemStyle: {
              normal: {
                color: "#F69638",
                shadowBlur: 20,
                shadowColor: "#333",
              },
            },
            symbolSize: 10,
            data: [{ value: [120.739743, 31.344089], name: "苏州" }],
          },
        ],
      });
      let index = 0;
      setTimeout(() => {
        let timeNum = setInterval(() => {
          let val = this.points[index];
          pointsLines.push([[120.739743, 31.344089], val.value]);
          xData.push(val);
          this.setEcharts(pointsLines, xData);
          index++;
          if (index >= this.points.length) {
            clearInterval(timeNum);
            this.clickEcharts(); //echarts点击事件
            this.popWindow(this.activeCom, false, false); //默认打开的弹窗
          }
        }, 500);
      }, 500);
      
      const amapComponent = myChart.getModel().getComponent("amap");
      const amap = amapComponent.getAMap();
      amap.setMinZoom(4);
      amap.setMaxZoom(12);
    },
    setEcharts(pointsLines, points) {
      let option = {
        backgroundColor: "transparent",
        amap: {
          center: this.center,
          zoom: this.zoom,
          viewMode: "3D",
          resizeEnable: true,
          mapStyle: "amap://styles/normal",
        },
        series: [
          {
            silent: true,
            type: "lines",
            coordinateSystem: "amap",
            zlevel: 2,
            effect: {
              show: true,
              period: 8, //箭头指向速度，值越小速度越快
              trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "arrow", //箭头图标
              symbolSize: 5, //图标大小
            },
            lineStyle: {
              normal: {
                color: "#00D9F8",
                width: 0.4, //尾迹线条宽度
                opacity: 1, //尾迹线条透明度
                curveness: 0.3, //尾迹线条曲直度
                type: "dashed",
              },
            },
            data: pointsLines,
          },
          {
            type: "effectScatter",
            coordinateSystem: "amap",
            showEffectOn: "render",
            zlevel: 1,
            rippleEffect: {
              period: 5,
              scale: 5,
              brushType: "fill",
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: (params) => {
                  var str = "";
                  str = "\n\n" + params.data.name;
                  return str;
                },
                position: "right",
                offset: [15, 0],
                color: "#00D9F8",
                show: true,
              },
            },
            itemStyle: {
              normal: {
                color: "#00D9F8",
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            symbolSize: 6,
            data: points,
          },
          {
            type: "effectScatter",
            coordinateSystem: "amap",
            showEffectOn: "render",
            zlevel: 1,
            rippleEffect: {
              period: 5,
              scale: 5,
              brushType: "fill",
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: (params) => {
                  var str = "";
                  str = params.data.name;
                  return str;
                },
                position: "top",
                offset: [30, 0],
                color: "#F69638",
                show: true,
              },
            },
            itemStyle: {
              normal: {
                color: "#F69638",
                shadowBlur: 5,
                shadowColor: "#333",
              },
            },
            symbolSize: 12,
            data: [{ value: [120.739743, 31.344089], name: "苏州" }],
          },
        ],
      };
      myChart.setOption(option);
    },
    clickEcharts() {
      myChart.on("click", (obj) => {
        this.popWindow(obj.data, true, false);
      });
    },
    popWindow(data, isEmit = true, changeZoom = true) {
      const amapComponent = myChart.getModel().getComponent("amap");
      const amap = amapComponent.getAMap();
      
      // 创建信息窗口
      let infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -20),
      });
      
      let MyComponent = Vue.extend({
        render: (h) =>
          h(InfoWindow, {
            props: {
              data: data,
            },
          }),
      });
      let baseComponent = new MyComponent().$mount();
      infoWindow.setContent(baseComponent.$el);
      
      // 设置信息窗口位置并打开
      let position = new AMap.LngLat(data.value[0], data.value[1]);
      infoWindow.open(amap, position);
      
      if (isEmit) {
        this.$emit("companyChange", data);
      }
      if (changeZoom) {
        amap.setZoom(5);
      }
    },
  },
};
</script>

<style lang="scss">
.mainMap {
  width: 74rem;
  overflow: hidden;
}

#bMain {
  padding: 0px;
  margin: 0px;
  height: 43.75rem;
}

// 隐藏地图左下版权
.amap-logo,
.amap-copyright {
  display: none !important;
}
</style>